// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PlaylistPlayer: MarkdocTagRegistration = {
  tag: 'playlist-player',
  component: 'PlaylistPlayer',

  attributes: {
    playlist: {
      type: String,
      required: true,
      description: 'The playlist ID matching in docs/videos/playlists.yaml',
    },
    settings: {
      type: String,
      required: true,
      matches: [
        'default',
        'server-only',
        'web-only',
        'web-with-next',
        'terminal',
      ],
      description:
        'What type of prefs to show for a given playlist. (Similar to the integration builder)',
    },
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'The title for the playlist shown in the playlist player',
    },
  },
};
